import { Button, CircularProgress, DialogActions } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import { ChangeLogAction } from './change-log-action';

export function AnswerKeyDialogActions({
  editing, submitting, canSave, canEdit, changeLog, studentName, onClose, onStartEditing, onCancelEditing, onSave,
}) {
  if (editing) {
    return (
      <DialogActions>
        <Button onClick={onCancelEditing} color="default" disabled={submitting}>
          Cancelar
        </Button>
        <Button
          onClick={onSave}
          color="primary"
          variant="contained"
          disabled={submitting || !canSave}
          startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
        >
          Salvar Alterações
        </Button>
      </DialogActions>
    );
  }

  return (
    <DialogActions>
      <ChangeLogAction changeLog={changeLog} studentName={studentName} />
      <Button onClick={onClose} color="default">
        Fechar
      </Button>
      <Button
        onClick={onStartEditing}
        color="primary"
        variant="contained"
        startIcon={<Edit />}
        disabled={!canEdit}
      >
        Editar
      </Button>
    </DialogActions>
  );
}
